import React from "react";
import "animate.css/animate.compat.css";
import Home from "./components/mainfiles/Home";
import About from "./components/mainfiles/About";
import Projects from "./components/mainfiles/Projects";
import Contact from "./components/mainfiles/Contact";
import Blogs from "./components/mainfiles/Blogs";
import Account from "./components/mainfiles/Account";
import PageNotFound from "./components/mainfiles/PageNotFound";
import Header from "./components/general/Header";
import Footer from "./components/general/Footer";
import AdminReports from "./components/admin/dailyReports";
import AdminClients from "./components/admin/network";
import ClientSidebar from "./components/clients/ClientSidebar";
import ClientReports from "./components/clients/ClientReports";
// import ClientMeetings from "./components/mainfiles/ClientMeetings";
import UserClients from "./components/clients/UserClients";
import Copyright from "./components/general/Copyright";
import Dashboard from "./components/clients/Dashboard";
import AdminDashboard from "./components/admin/dashboard";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import BlogHistory from "./components/admin/blogHistory";
// import AdminMeetings from "./components/admin/AdminMeetings";
import ClientRewards from "./components/clients/ClientRewards";
import AvinashKumar from "./components/mainfiles/AvinashKumar";
import RajKumar from "./components/mainfiles/RajKumar";
import NirajPandey from "./components/mainfiles/NirajPandey";
import KrishnaKumar from "./components/mainfiles/KrishnaKumar";
import AbhishekRai from "./components/mainfiles/AbhishekRai";
import SagarKataria from "./components/mainfiles/Sagarkataria";
import ScrollTop from "./components/general/ScrollTop";
// import ClientProfile from "./components/mainfiles/ClientProfile";
import DailyReport from "./components/general/DailyReport";
import AdminSidebar from "./components/admin/adminSidebar";
// import AdminProfile from "./components/admin/AdminProfile";
import AdminSites from "./components/admin/addSites";
import AdminPlot from "./components/admin/addPlots";
import PlotInventory from "./components/general/inventory";
import SaleHistory from "./components/admin/saleHistory";
import ManageDues from "./components/admin/manageDues";
import ClientSale from "./components/clients/ClientSale";
import AdminRewards from "./components/admin/rewards";
import AdminSale from "./components/admin/addSale";
import Milestones from "./components/clients/Milestones";
import SalaryPage from "./components/clients/salary";
import ClientProfile from "./components/clients/ClientProfile";

const App = () => {
  const userActive = localStorage.getItem("user");
  const userDetails = JSON.parse(userActive);
  const userId = parseInt(userDetails?.id);
  const collapsed = false;

  return (
    <BrowserRouter>
      <ScrollTop />
      {!userDetails && (
        <>
          <div className="main-content">
            <Header />
            <Routes>
              <Route exact path="/" element={<Home />} />
              <Route exact path="/about" element={<About />} />
              <Route exact path="/projects" element={<Projects />} />
              <Route
                exact
                path="/members/avinash-kumar"
                element={<AvinashKumar />}
              />
              <Route exact path="/members/raj-kumar" element={<RajKumar />} />
              <Route
                exact
                path="/members/niraj-pandey"
                element={<NirajPandey />}
              />
              <Route
                exact
                path="/members/krishna-kumar"
                element={<KrishnaKumar />}
              />
              <Route
                exact
                path="/members/abhishek-rai"
                element={<AbhishekRai />}
              />
              <Route
                exact
                path="/members/sagar-kataria"
                element={<SagarKataria />}
              />
              <Route exact path="/blogs" element={<Blogs />} />
              <Route exact path="/contact" element={<Contact />} />
              <Route exact path="/account" element={<Account />} />
              <Route exact path="*" element={<PageNotFound />} />
            </Routes>
          </div>
          <Footer />
        </>
      )}

      {userDetails && userId === 1 && (
        <>
          <AdminSidebar userDetails={userDetails} />
          <div
            className={`dashboard-sidebar-right ${
              collapsed ? "collapsed" : ""
            }`}
          >
            <Routes>
              <Route
                exact
                path="/"
                element={<AdminDashboard userDetails={userDetails} />}
              />
              <Route
                exact
                path="/admin/dashboard"
                element={<AdminDashboard userDetails={userDetails} />}
              />
              {/* <Route
                exact
                path="/admin/profile"
                element={<AdminProfile userDetails={userDetails} />}
              /> */}
              <Route exact path="/admin/add-plot" element={<AdminPlot />} />
              <Route
                exact
                path="/admin/plot-inventory"
                element={<PlotInventory />}
              />
              <Route
                exact
                path="/admin/team"
                element={<AdminClients userDetails={userDetails} />}
              />
              <Route exact path="/admin/reports" element={<AdminReports />} />
              <Route exact path="/admin/add-sale" element={<AdminSale />} />
              <Route exact path="/admin/add-sites" element={<AdminSites />} />
              <Route exact path="/admin/manage-dues" element={<ManageDues />} />
              <Route
                exact
                path="/admin/team-rewards"
                element={<AdminRewards />}
              />
              <Route
                exact
                path="/admin/blogs-posted"
                element={<BlogHistory />}
              />
              <Route
                exact
                path="/admin/sale-history"
                element={<SaleHistory userData={userDetails} />}
              />
              <Route exact path="*" element={<PageNotFound />} />
            </Routes>
          </div>
          <Copyright />
        </>
      )}

      {userDetails && userId !== 1 && (
        <>
          <ClientSidebar userDetails={userDetails} />
          <div
            className={`dashboard-sidebar-right ${
              collapsed ? "collapsed" : ""
            }`}
          >
            <Routes>
              <Route
                exact
                path="/"
                element={<Dashboard userDetails={userDetails} />}
              />
              <Route
                exact
                path="/user/dashboard"
                element={<Dashboard userDetails={userDetails} />}
              />
              <Route
                exact
                path="/user/profile"
                element={<ClientProfile userDetails={userDetails} />}
              />
              <Route
                exact
                path="/user/milestone"
                element={<Milestones userDetails={userDetails} />}
              />
              <Route
                exact
                path="/user/add-report"
                element={<DailyReport userDetails={userDetails} />}
              />
              <Route
                exact
                path="/user/team"
                element={<UserClients userDetails={userDetails} />}
              />
              <Route
                exact
                path="/user/reports"
                element={<ClientReports userDetails={userDetails} />}
              />
              <Route
                exact
                path="/user/plot-inventory"
                element={<PlotInventory />}
              />
              <Route
                exact
                path="/user/salary"
                element={<SalaryPage userDetails={userDetails} />}
              />
              {/* <Route
                exact
                path="/user/meeting"
                element={<ClientMeetings userDetails={userDetails} />}
              /> */}
              <Route
                exact
                path="/user/sale-history"
                element={<ClientSale userDetails={userDetails} />}
              />
              <Route
                exact
                path="/user/reward-history"
                element={<ClientRewards userDetails={userDetails} />}
              />
              <Route exact path="*" element={<PageNotFound />} />
            </Routes>
          </div>
          <Copyright />
        </>
      )}
    </BrowserRouter>
  );
};

export default App;
